import { Primary, PrimaryDark } from './Palettes';
export const palette = {
    primary: Primary,
    primaryDark: PrimaryDark,
};
